export const iconFontAwesomeDesignBrush = (
	<i className="fa-solid fa-brush"></i>
);
